import { HOME_INSPECTION_TYPES } from '@app/listing/constants';
import { ShowingScreenType, type OverrideOptionType } from './types';

export const OVERRIDE_OPTIONS: { label: string; value: OverrideOptionType }[] =
  [
    {
      label: 'I need to book an Appraisal Visit',
      value: 'Appraisal',
    },
    {
      label: 'I need to book a Home Inspection Visit',
      value: 'Home Inspection',
    },
    ...HOME_INSPECTION_TYPES.map((value: OverrideOptionType) => ({
      label: `I need to book a ${value}`,
      value,
    })),
    {
      label: 'I need to book a Photographer Visit',
      value: 'Photographer',
    },
    {
      label: 'I need to book a Pest Control Visit',
      value: 'Pest Control',
    },
    {
      label: 'I need to book a Final Walk-Through with my buyers',
      value: 'Final Walkthrough',
    },
  ];

// Exhaustive list of all possible override types.
export const SHOWING_SCREEN_DECISION_TREE: any = {
  canEdit: {
    default: {
      noMoreShowings: ShowingScreenType.AdminOverride,
      default: ShowingScreenType.Default,
    },
  },
  default: {
    'Sold | Leased | Pending': ShowingScreenType.AgentOverride,
    'Leased Conditionally | Sold Conditionally': {
      noMoreShowings: ShowingScreenType.AgentOverride,
      default: ShowingScreenType.Default,
    },
    'Suspended | Terminated | Expired': ShowingScreenType.Forbid,
    default: {
      noMoreShowings: ShowingScreenType.Forbid,
      default: ShowingScreenType.Default,
    },
  },
};
